// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/es7.weak-map.from.js
// module id = 322
// module chunks = 0